<template>
        <img ref="previewImage" :src="src" id="previewImageID"/>
</template>

<script>
export default {
  data() {
    return {
      width: null,
      height: null
    }
  },
  props: ['src'],
  mounted() {
    this.$refs.previewImage.addEventListener('load', () => {
      var img = document.querySelector('img#previewImageID')
      this.width = img.naturalWidth
      this.height = img.naturalHeight
      this.$emit('update', this.width, this.height)
    })
  }
}
</script>

<style scoped lang="scss">
img {
  width: 100%;
  max-height: calc(100vh);
  min-height: 560px;
}

@media (max-width: 991.98px) {
  img {
    min-width: 100%;
    min-height: auto;
    max-height: none;
  }
}
</style>
